function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 3h-.5c-1.395 0-2.092 0-2.667.138a5 5 0 00-3.695 3.695C3 7.408 3 8.105 3 9.5V13c0 2.8 0 4.2.545 5.27a5 5 0 002.185 2.185C6.8 21 8.2 21 11 21h3.5c1.395 0 2.092 0 2.667-.138a5 5 0 003.695-3.695C21 16.592 21 15.894 21 14.5V14m-9-2l9-9m0 0h-6m6 0v6",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgOpenInNew = function SvgOpenInNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#E9EAF1"
  }, props), _ref);
};

export default SvgOpenInNew;